import React from "react";
import Logo from "../resources/Logo petromin.png";
import { Link } from "react-router-dom";

function NavbarForFuel() {
  return (
    <nav className="bg-white shadow-xl z-50 fixed top-0 left-0 w-full">
      <div className="absolute top-0 left-0 w-full h-1.5 bg-red-600"></div>
      <div className="px-6 flex items-center mx-auto h-24">
        <Link to="/">
          <img src={Logo} alt="logo" className="h-12" />
        </Link>
      </div>
    </nav>
  );
}

export default NavbarForFuel;
